import { DigitalSignatureLogo } from "@smart/itops-sb-design-system-dom";

import { SignatureLogoVariant, useSignatureLogoVariant } from "../../../hooks";
import { getUITranslation, splitUITranslation } from "../../../utils";

type DigitalSignatureFieldProps = {
  variant?: SignatureLogoVariant;
  selectedLanguage?: string;
};

export const DigitalSignatureField = ({
  variant,
  selectedLanguage,
}: DigitalSignatureFieldProps) => {
  const variantFromContext = useSignatureLogoVariant();
  const logoVariant = variant ?? variantFromContext;
  const providerName = logoVariant === "trisign" ? "triSign" : "SignIT";
  const [beforeAction, afterAction] = splitUITranslation(
    "digitalSignatureCalloutBody",
    "action",
    selectedLanguage,
    { provider: providerName },
  );

  return (
    <div className="flex p-[1.6rem] rounded bg-blue-60/50 w-full min-h-[8rem] border border-solid border-blue-160">
      <div className="flex gap-medium">
        <DigitalSignatureLogo variant={logoVariant} className="h-[2.5rem]" />
        <div className="flex flex-col gap-small">
          <p className="text-ui font-semibold">
            {getUITranslation("signatureRequired", selectedLanguage)}
          </p>
          <p className="text-caption">
            {beforeAction}
            <strong>
              {getUITranslation("submitAndSign", selectedLanguage)}
            </strong>
            {afterAction}
          </p>
        </div>
      </div>
    </div>
  );
};
